module.exports = __webpack_public_path__ + "static/media/poron_talon.04d21473.png";